import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { MDBCol, MDBRow } from "mdbreact";

import "./Corrections.scss";

import { Input, Label } from "abs-ui-components";

import axiosHttp from "../../../services/interceptor";
import { emitToasterMsg } from "../../../services/toasterUtility";

const PlanVerificationCorrectionRequestForm = ({
	toggleCorrection,
	planDetails,
	isRepliedCorrection,
	parentCorrectionData,
	fetchData, // Receiving the callback function
	refreshState,
}) => {
	const {
		control,
		handleSubmit,
		trigger,
		formState: { errors },
	} = useForm();
	const [disableButtons, setDisableButtons] = useState(false);

	const addCorrectionRequest = async (payload,wcnNumber) => {
		try {
			const response = await axiosHttp.post(
				`api/PlanVerification/AddCorrection?wcnNumber=${encodeURIComponent(wcnNumber)}`,
				payload
			);

			if (response?.data) {
				setDisableButtons(false);
				emitToasterMsg("success", "Correction Request", "Correction Request Raised Successfully");
				toggleCorrection(true);
				fetchData(); // Call fetchData after successful request
				await (refreshState?.());
			}
		} catch (error) {
			setDisableButtons(false);
			emitToasterMsg("error", "Error", error.message);
		}
	};

	const addCorrectionReplyMessage = async (repliedMsgPayload,wcnNumber) => {
		try {
			const serverPayload = {
				PlanId: String(repliedMsgPayload.PlanId),
				PlanCorrectionId: String(repliedMsgPayload.PlanCorrectionId),
				Message: String(repliedMsgPayload.Message),
			};

			const response = await axiosHttp.post(
				`api/PlanVerification/AddCorrectionMessage?wcnNumber=${encodeURIComponent(wcnNumber)}`,
				serverPayload
			);

			if (response?.data) {
				setDisableButtons(false);
				emitToasterMsg("success", "Correction Reply Message", "Reply Sent Successfully");
				toggleCorrection(true);
				fetchData(); // Refresh data after successful reply
			}
		} catch (error) {
			setDisableButtons(false);
			emitToasterMsg("error", "Error", error?.message);
		}
	};


	const handleCorrectionForm = async (formdata) => {
		setDisableButtons(true);
		if (!isRepliedCorrection) {
			const payload = {
				PlanId: String(planDetails.PlanId),
				CorrectionHeader: formdata.textCorrection,
				CorrectionMessage: formdata.replyMessage,
			};
			await addCorrectionRequest(payload, planDetails.WcnNumber);
		} else {
			const repliedMsgPayload = {
				PlanId: String(planDetails.PlanId),
				PlanCorrectionId: String(parentCorrectionData.planCorrectionId),
				Message: formdata.replyMessage,
			};
			await addCorrectionReplyMessage(repliedMsgPayload, planDetails.WcnNumber);
		}
	};

	const handleBlur = async (field, value) => {
		await trigger(field);
	};

	return (
		<div className="container-fluid modal-height">
			<form onSubmit={handleSubmit(handleCorrectionForm)}>
				<MDBRow>
					{isRepliedCorrection ? (
						""
					) : (
						<MDBCol md="12">
							<Controller
								name="textCorrection"
								control={control}
								rules={{
									required: "field is required",
								}}
								render={({ field }) => (
									<Input
										id="text-correction"
										{...field}
										autoFocus={false}
										type="text"
										placeholder="Text Correction"
										className="p-2"
										disabled={isRepliedCorrection}
										value={field.value}
										onChange={field.onChange}
										onBlur={(e) => handleBlur(field.name, field.value)}
									/>
								)}
							/>
							{errors?.textCorrection && <div className="error-msg mb-2">{errors.textCorrection.message}</div>}
						</MDBCol>
					)}
				</MDBRow>
				<MDBRow>
					<MDBCol md="12">
						<Label name="Message" className="mb-1 mt-1" />
					</MDBCol>
				</MDBRow>
				<MDBRow>
					<MDBCol md="12">
						<Controller
							name="replyMessage"
							control={control}
							defaultValue=""
							rules={{
								required: "field is required",
							}}
							render={({ field }) => (
								<Input
									id="reply_message"
									autoFocus={false}
									value={field.value}
									onChange={field.onChange}
									{...field}
									type="text"
									placeholder="Type your reply message here"
									className="p-2"
									onBlur={(e) => handleBlur(field.name, field.value)}
								/>
							)}
						/>
						{errors?.replyMessage && <div className="error-msg mb-2">{errors.replyMessage.message}</div>}
					</MDBCol>
				</MDBRow>
				<div className="mt-5 mb-2 corrections-save-cancel-btn-wrapper">
					<div className="mt-3">
						<div className="d-flex justify-content-end">
							<button className="btn mr-2 enroll-submit-btn" disabled={disableButtons} type="submit">
								Save
							</button>
							<button
								id="enroll_vessel_cancel_button"
								className="btn fleet-cancel-btn"
								disabled={disableButtons}
								type="button"
								onClick={toggleCorrection}
							>
								Cancel
							</button>
						</div>
					</div>
				</div>
			</form>
		</div>
	);
};

export default PlanVerificationCorrectionRequestForm;
